// extracted by mini-css-extract-plugin
export default {"content":"styles_content__aFKsl","buttons":"styles_buttons__E4mZQ","button":"styles_button__NlL9Q"};